// extracted by mini-css-extract-plugin
export default {"addressText":"Address_addressText__QPvUT"};